import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export const WHITESPACE_REGEX = /\s+/;

/**
 * Get initials from a display name. Returns '?' for empty/blank names.
 * Uses first letter of first word + first letter of last word for multi-word names,
 * or first two characters for single-word names.
 */
export const getInitials = (name: string): string => {
  const trimmed = name.trim();
  if (!trimmed) {
    return '?';
  }
  const parts = trimmed.split(WHITESPACE_REGEX);
  if (parts.length >= 2) {
    return `${parts.at(0)?.at(0) ?? ''}${parts.at(-1)?.at(0) ?? ''}`.toUpperCase();
  }
  return trimmed.slice(0, 2).toUpperCase();
};

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
